import { createAction } from "redux-api-middleware";
import AppSettings from "../config";
import networkSelectors from "../selectors/network";

export const GET_IDENTITY_LOADING = "GET_IDENTITY_LOADING";
export const GET_IDENTITY_SUCCESS = "GET_IDENTITY_SUCCESS";
export const GET_IDENTITY_FAILURE = "GET_IDENTITY_FAILURE";

export function getIdentity() {
  return createAction({
    endpoint: `${AppSettings.IDENTITY_API_URL}/me`,
    method: "GET",
    headers: networkSelectors.defaultHeaders,
    types: [GET_IDENTITY_LOADING, GET_IDENTITY_SUCCESS, GET_IDENTITY_FAILURE],
  });
}
